<!-- Full Screen Overlay -->
<div class="generic-split-screen-overlay">
  <!-- Main Container -->
  <div class="generic-split-screen-container" [class.full-screen-mode]="config.fullScreen">
    <!-- Left Section -->
    <div class="generic-split-screen-left-section">
      <!-- Left Content - Content Projection -->
      <ng-content select="[slot=left-content]"></ng-content>
    </div>

    <!-- Right Section (conditional) -->
    <div class="generic-split-screen-right-section" *ngIf="config.showRightSection">
      <!-- Right Content - Content Projection -->
      <ng-content select="[slot=right-content]"></ng-content>
    </div>
  </div>
</div>
